import {
  Button, Dialog, Modal, useKeyboardEvent,
} from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import { useTranslation } from 'react-i18next';

type TDeleteModalParams<T = unknown> = {
  onClose: () => void,
  onSubmit: () => void;
  entity: Partial<T> & { rawName?: string, name?: string, objectid?: string }
};

export const DeleteModal = ({
  onClose,
  onSubmit,
  entity,
}: TDeleteModalParams) => {
  const { t } = useTranslation();
  useKeyboardEvent('Enter', onSubmit);
  const name = entity?.objectid ? entity.rawName : entity?.name;

  return (
    <Modal
      centered
      visible
      onEscape={onClose}
    >
      <Dialog
        dialog={{
          heading: t(translations.delete),
          content: t(translations.hierarchy_deleteHierarchyItemWarning, { hierarchyItem: name }),
          footer: (
            <>
              <Button
                label={t(translations.delete)}
                colored="red"
                onClick={onSubmit}
              />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};
